// extracted by mini-css-extract-plugin
export default {"title":"NAa0_1","content":"oicHgJ","cta":"UQi0VZ"};